<section class="vc-admin-products-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.PRODUCTS.ALL"
    descriptionKey="ADMIN.IA.PRODUCTS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'products', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredProducts.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.PRODUCTS.EMPTY.TITLE"
      descriptionKey="ADMIN.PRODUCTS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
      [value]="filteredProducts"
      responsiveLayout="scroll"
      [autoLayout]="true"
      styleClass="Table"
    >
      <ng-template pTemplate="header">
        <tr>
          <th [width]="'120px'">{{ "COMMON.COLOR" | translate }}</th>
          <th [width]="'120px'">
            {{ "COMMON.IMAGE" | translate }}
          </th>
          <th>{{ "COMMON.CATEGORY" | translate }}</th>
          <th>{{ "COMMON.NAME" | translate }}</th>
          <th>{{ "COMMON.DESCRIPTION" | translate }}</th>
          <th>{{ "COMMON.ACTIONS" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product>
        <tr>
          <td>
            <div
              class="product-color"
              [style]="{ 'background-color': product.color }"
            ></div>
          </td>

          <td>
            <app-product-image
              [style]="{ 'text-align': '-webkit-center' }"
              [image_url]="product.image_url"
              [size]="'50px'"
            ></app-product-image>
          </td>
          <td>{{ product.category?.name }}</td>
          <td>{{ product.name }}</td>
          <td>{{ product.description }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'products',
                product.id
              ]"
              (delete)="confirmDelete(product)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
